export default {
  // Common
  "Email": "电子邮件",
  "Email *": "电子邮件 *",
  "Password": "密码",
  "Dashboard": "主页",
  "Overview": "概要",
  "Giving": "奉献",
  "GIVING": "奉献",
  "History": "过往纪录",
  "Subscriptions": "定期基督徒奉献",
  "Planned Giving": "定期基督徒奉献",
  "SUBSCRIPTIONS": "定期基督徒奉献",
  "Planned Christian Giving": "定期基督徒奉献",
  "Recurring Instructions": "定期指示",
  "Tax Receipts": "税务收据",
  "Login": "登录",
  "Logout": "登出",
  "Cancel": "取消",
  "Disabled": "已停用",
  "Do Not Unsubscribe": "不取消订阅",
  "Confirm": "确认",
  "Complete Payment": "完成付款",
  "Type": "类型",
  "Confirm Payment": "确认付款",
  "Processing...": "处理中...",
  "OK": "确定",
  "Error": "错误",
  "Success": "成功",
  "Back": "返回",
  "Save": "保存",
  "Edit": "编辑",
  "Delete": "删除",
  "Download": "下载",
  "View": "查看",
  "Actions": "操作",
  "Subscription Ref ID: ": "定期基督徒奉献参考编号：",
  "Subscription ID": "定期基督徒奉献编号",
  "Subscription Details": "定期基督徒奉献详情",
  "Subscription Status": "定期基督徒奉献状态",
  "Start Date": "开始日期",
  "Customer ID": "客户编号",
  "Token ID": "令牌编号",
  "Unsubscribe": "取消订阅",
  "Last Payment Date": "上次付款日期",
  "Details": "详情",
  "Past Givings": "过往奉献",
  "No past givings found": "没有找到过往奉献记录",
  "Close": "关闭",
  "Are you sure you want to unsubscribe this PCG instruction?": "确定要取消此定期奉献指示吗？",
  "The subscription was successfully cancelled.": "订阅已成功取消。",
  "Subscription Cancelled": "订阅已取消",
  "Filter": "筛选",
  "Filter Options": "筛选选项",
  "Date (From)": "日期（起）",
  "Date (To)": "日期（止）",
  "Saving...": "保存中...",
  "Loading...": "载入中...",
  "(Optional)": "(选填)",
  "Password *": "密码 *",
  "Confirm Password *": "确认密码 *",
  "Weak Password": "弱密码",
  "Password does not meet strength requirements. Please check the checklist and try again.": "密码不符合强度要求。请检查清单并重试。",
  "Phone": "电话",
  "Service": "聚会时间",
  "Since": "自从",
  "Payment Method": "付款方式",
  "Search": "搜索",
  "Pending": "未完成",
  "Completed": "已完成",
  "Cancelled": "已取消",
  "Enabled": "已啟用",
  "Clear Filters": "清除筛选器",
  "Once": "一次",
  "Monthly": "每月",
  "Yearly": "每年",

  // Receipt Selection
  "Require a receipt": "需要收据",
  "Do not require a receipt": "不需要收据",
  "Receipt No.": "收据编号",

  // Payment Status
  "THANK YOU FOR YOUR SUPPORT!": "感谢您的支持！",
  "PAYMENT FAILED": "付款失败",

  // HomePage
  "Enter the 6-digit code": "输入 6 位数验证码",
  "Not a member yet?": "还不是会员？",
  "Create an account": "创建账户",
  "Forgot Password?": "忘记密码？",
  "Your account is pending verification. Please check your email for the verification code and": "您的账户待验证。请检查您的电子邮件以获取验证码，并",
  "enter it in this page": "在此页面输入",

  // Registration
  "CREATE ACCOUNT": "创建账户",
  "Which Is Your Regular Service?": "您通常参加哪个聚会？",
  "There are errors in the form. Please check the form and try again.": "表单有错误。请检查表单并重试。",
  "Your email is registered but not verified. Please check your email for verification instructions.": "您的电子邮件已注册但未验证。请检查您的电子邮件以获取验证说明。",
  "Email Not Verified": "电子邮件未验证",
  "Creating Account...": "创建账户中...",
  "Create Account": "创建账户",
  "Only numbers are allowed": "仅允许数字",
  "This field is required": "此栏是必填项",
  "This field must be a valid e-mail": "此栏位必须是有效的电子邮件",
  "Others": "其他",
  "Only English characters are allowed": "仅允许英文字符",
  "Only Chinese characters are allowed": "仅允许中文字符",
  "Must be at least 8 characters long": "必须至少 8 个字符长",
  "Show password": "显示密码",
  "Hide password": "隐藏密码",
  "At least 8 characters": "至少 8 个字符",
  "At least 1 uppercase letter": "至少 1 个大写字母",
  "At least 1 lowercase letter": "至少 1 个小写字母",
  "At least 1 number or special character": "至少 1 个数字或特殊字符",

  // Verify Account
  "VERIFY ACCOUNT": "验证账户",
  "Account Verified Successfully!": "账户验证成功！",
  "Your account has been verified. Redirecting to login...": "您的帐户已通过验证。正在跳转至登录页面...",
  "A 6-digit verification code has been sent to your email address. Please enter the code below to verify your account.": "已向您的电子邮件地址发送 6 位数验证码。请在下方输入验证码以验证您的账户。",
  "Verification failed. Please check your code and try again.": "验证失败。请检查您的验证码并重试。",
  "6-Digit Verification Code": "6 位数验证码",
  "000000": "000000",
  "Didn't receive the code?": "没有收到验证码？",
  "Resending...": "重新发送中...",
  "Resend in {{count}}s": "{{count}}秒后重新发送",
  "Resend Code": "重新发送验证码",
  "Verifying...": "验证中...",
  "Verify Account": "验证账户",
  "Back to Login": "返回登入页面",
  "A new verification code has been sent to your email.": "新的验证码已发送到您的电子邮件。",
  "Code Resent": "验证码重发",
  "Failed to resend verification code. Please try again.": "无法重新发送验证码。请重试。",
  "Please enter a valid 6-digit verification code.": "请输入有效的 6 位数验证码。",
  "Invalid Input": "输入无效",
  "Email is required to resend verification code.": "需要电子邮件才能重新发送验证码。",

  // Forgot Password
  "FORGOT PASSWORD": "忘记密码",
  "Enter your email address and we'll send you a verification code to reset your password.": "输入您的电子邮件地址，我们会向您发送验证码以重设密码。",
  "Failed to send verification code. Please try again.": "无法发送验证码。请重试。",
  "your.email@example.com": "your.email@example.com",
  "Please enter a valid email address.": "请输入有效的电子邮件地址。",
  "Sending...": "发送中...",
  "Send Verification Code": "发送验证码",

  // Verify Code
  "VERIFY CODE": "验证验证码",
  "A 6-digit verification code has been sent to your email address. Please enter the code below to continue.": "已向您的电子邮件地址发送 6 位数验证码。请在下方输入验证码以继续。",
  "Verify Code": "验证验证码",
  "Back to Forgot Password": "返回\"忘记密码\"",

  // Reset Password
  "RESET PASSWORD": "重设密码",
  "Enter your new password below.": "在下方输入您的新密码。",
  "Failed to reset password. Please try again.": "无法重设密码。请重试。",
  "New Password": "新密码",
  "Password must be at least 8 characters": "密码必须至少 8 个字符",
  "Enter new password": "输入新密码",
  "Confirm New Password": "确认新密码",
  "Passwords do not match": "密码错误",
  "Re-enter your new password": "重新输入您的新密码",
  "Your password has been successfully reset. You can now login with your new password.": "您的密码已成功重设。您现在可以使用新密码登录。",
  "Password Reset Successful": "密码重设成功",
  "Passwords do not match. Please try again.": "密码错误。请重试。",
  "Password Mismatch": "密码错误",
  "Please fill in all required fields correctly.": "请正确填写必要项目。",
  "Resetting...": "重设中...",
  "Reset Password": "重设密码",

  // Dashboard
  "Give": "奉献",
  "PCGID: ": "PCGID: ",
  "Last Giving": "上次奉献",
  "Giver for ": "奉献者 ",
  "month": "个月",
  "months": "个月",
  "HKD": "港币",
  "Total Amount (Fiscal Year To Date)": "总金额（本财政年度至今）",
  "RECENT GIVING": "最近奉献",
  "Date": "日期",
  "Amount": "金额",
  "Fund": "基金",
  "Next Billing Date": "下次扣款日期",
  "Recurring Monthly Amount": "每月定期奉献金额",
  "Status": "状态",
  "Ref ID": "参考编号",
  "No recent giving found": "未找到最近的奉献",

  // Give Page
  "FREQUENCY": "频率",
  "AMOUNT": "金额",
  "PAYMENT CONFIRMATION": "付款确认",
  "Please Note: By choosing 'Do Not Require A Receipt', no receipt shall be issued or requested in the future regards to the giving, yet email is compulsory for each giving for issuing confirmation email and documentation purpose.": "请注意：选择「不需要收据」后，本堂将不会就是次奉献发出收据，每次奉献都必须提供电邮地址以作核实及存档。",
  "Click this button to proceed to the QFPay payment page": "点击此按钮前往 QFPay 付款页面",
  "GIVE ": "奉献 ",
  " NOW": " 立即",
  "GIVE {{amount}} NOW": "立即奉献{{amount}}",
  "Payment Failed": "付款失败",
  "An error occurred during payment. Please try again.": "付款过程中发生错误。请再试一次。",

  // History
  "HISTORY": "过往纪录",
  "GIVING RECORD": "奉献记录",

  // Subscriptions
  "Planned Amount": "定期奉献金额",
  "Planned Status": "定期奉献状态",

  // Profile
  "Profile": "资料",
  "MY PROFILE": "我的资料",
  "Personal Information": "个人信息",
  "First Name (English) *": "名字（英文）*",
  "Last Name (English) *": "姓氏（英文）*",
  "First Name (Chinese)": "名字（中文）",
  "Last Name (Chinese)": "姓氏（中文）",
  "Name on Tax Receipt": "税务收据上的名字",
  "Name on Tax Receipt *": "税务收据上的名字 *",
  "Used for issuing tax receipt. Default to First Name and Last Name": "用于发出税务收据。预设为名字和姓氏",
  "Phone *": "电话 *",
  "Change Password (Optional)": "更改密码（可选）",
  "Leave password fields blank if you don't want to change your password.": "如果您不想更改密码，请将密码栏位留空。",
  "Current Password": "目前密码",
  "Your profile has been updated successfully.": "您的资料已成功更新。",
  "Save Profile": "保存资料",

  // Receipts
  "TAX RECEIPTS": "税务收据",
  "ISSUED TAX RECEIPTS": "已发出的税务收据",
  "Financial Year:": "财政年度：",

  // Not Found
  "Page not found": "找不到页面",
  "Redirecting to dashboard in ": "重新导向到主页于 ",

  // Portal Header
  "The login session is expired. Please login again.": "登录阶段已过期。请重新登录。",
  "Are you sure you want to logout?": "您确定要登出吗？",

  // File Upload
  "Drop file here to upload": "将文件拖放到此处上传",
  "Drop file here or click to upload.": "将文件拖放到此处或点击上传。",
  "Accept file upload within 10 MB": "接受 10 MB 以内的文件上传",

  // General List Layout
  "The ": "该 ",
  " is sent to the customer successfully.": " 已成功发送给客户。",
  " Sent": " 已发送",
  "Failed to send the ": "无法发送 ",
  " to the customer.": " 给客户。",
  "Failed to Send ": "发送失败 ",
  "Selected ": "已选择 ",
  "Item": "项目",
  "Items": "项目",

  // Delete Dialog
  "Delete ": "删除 ",
  "Are you sure you want to delete this ": "您确定要删除此 ",

  // View Page Header
  "View ": "查看 ",

  // Entry Pages - additional keys
  "100.00": "100.00",
  "You have successfully made a {{term}} giving to": "您已成功作出{{term}}捐献至",
  "Amount: HKD ": "金额：港币 ",
  "Ref ID: ": "参考编号：",
  "You can view your giving history in the": "您可以在",
  "history": "过往纪录",
  "section": "部分查看您的捐献记录",
  "A confirmation email has been sent to your email address.": "确认电邮已发送至您的电邮地址。",
  "Unfortunately, your payment for the giving to": "很抱歉，您捐献至",
  "Unfortunately, your payment for the giving to ": "很抱歉，您捐献至 ",
  "could not be processed": "的付款无法处理",
  " could not be processed.": " 的付款无法处理。",
  "Please check your payment details and try again": "请检查您的付款详情并重试",
  "Please check your payment details and try again.": "请检查您的付款详情并重试。",
  "TRY AGAIN": "重试",
  "Need help": "需要协助",
  "Contact Support": "联络支援",
  "Need help?": "需要帮助吗？请联络该<hyperlink>机构</hyperlink>寻求协助。",

  // Confirmation Page
  "Confirm Recurring Payment": "确认定期捐献",
  "Please review your recurring payment details before confirming": "请在确认前检查您的定期捐献详情",
  "Confirm and Proceed to Payment": "确认并前往付款",
  "Edit Details": "编辑详情",
};
